export enum SubscriptionTier {
    FREEBIE = 'tier.freebie',
    FREE = 'tier.free',
    STARTER = 'tier.starter',
    PREMIUM = 'tier.premium',
    ENTERPRISE = 'tier.enterprise'
}
